import { CheckUtils, CustomerAppVoData } from "../..";
var CustomerAppConverter = /** @class */ (function () {
    function CustomerAppConverter() {
    }
    CustomerAppConverter.convertCustomerPortalsToVo = function (customerPortalsApiData) {
        var result = [];
        if (!CheckUtils.isEmpty(customerPortalsApiData)) {
            Object.keys(customerPortalsApiData).forEach(function (key) {
                result.push(CustomerAppConverter.convertCustomerPortalToVo(customerPortalsApiData[key]));
            });
        }
        return result;
    };
    CustomerAppConverter.convertCustomerPortalToVo = function (customerPortalApiData) {
        var customerPortalVoData = new CustomerAppVoData(customerPortalApiData.id);
        customerPortalVoData.name = customerPortalApiData.name;
        customerPortalVoData.type = customerPortalApiData.type;
        customerPortalVoData.typeId = customerPortalApiData.typeId;
        customerPortalVoData.userType = customerPortalApiData.userType;
        customerPortalVoData.activated = customerPortalApiData.activated;
        customerPortalVoData.accessPolicy = customerPortalApiData.accessPolicy;
        customerPortalVoData.file = customerPortalApiData.file;
        customerPortalVoData.iconName = customerPortalApiData.iconName;
        customerPortalVoData.iconColor = customerPortalApiData.iconColor;
        customerPortalVoData.position = customerPortalApiData.position;
        customerPortalVoData.configurableFormIds = customerPortalApiData.configurableFormIds;
        return customerPortalVoData;
    };
    return CustomerAppConverter;
}());
export { CustomerAppConverter };
//# sourceMappingURL=customer-app-converter.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/utils/converter/customer-app-converter.js
// module id = 843
// module chunks = 14